/*
 * @Description: 价格文本
 * @Author: oubu
 * @Date: 2020-03-19
 */
import React, { Component } from 'react';
import './index.less';
import { Flex } from 'antd-mobile';
import PropTypes from 'prop-types';
import Util from 'utils';

import cx from 'classnames';
import { ImgWrap } from 'pubBiz';
import { throttle, debounce } from 'lodash';
import Config from 'config/Config';
import CommonBtn from '../CommonBtn/CommonBtnView';

const CDN_BASE = Config.CDN_BASE || '';

let interval = null;
let topValue = 0;
export default class PriceTextView extends Component {
  static propTypes = {
    onClick: PropTypes.func,
    scrollInRefeshView: PropTypes.bool,
    anchorName: PropTypes.string,
    special: PropTypes.bool
  };

  static defaultProps = {
    onClick: null,
    scrollInRefeshView: false,
    anchorName: 'ScrollTopView', //锚点名
    special: false
  };

  constructor(props, context) {
    super(props, context);
    this.state = {
      show: false
    };
  }

  //在componentDidMount，进行scroll事件的注册，绑定一个函数，让这个函数进行监听处理
  componentDidMount() {
    window.addEventListener(
      'scroll',
      throttle((e) => {
        this.bindHandleScroll(e);
      }, 100),
      true
    );
  }

  bindHandleScroll = (event) => {
    const normalview = document.querySelector('.normal-view');
    if (!!normalview) {
      const rightValue = window.getComputedStyle(document.querySelector('.normal-view'), null)[
        'right'
      ];
      if (rightValue >= '0px') {
        document.querySelector('.normal-view').className = 'normal-view';
        document.querySelector('.normal-view').style.visibility = 'visible';

        window.requestAnimationFrame(function (time) {
          window.requestAnimationFrame(function (time) {
            document.querySelector('.normal-view').className = 'normal-view changeing';
            document.querySelector('.changeing').style.animationPlayState = 'running';
            document.querySelector('.changeing').style.animationDirection = 'normal';
          });
        });
      }
      if (interval == null) {
        // 未发起时，启动定时器，1秒1执行
        interval = setInterval(function () {
          if (event.srcElement.scrollTop == topValue) {
            if (rightValue <= '-90px') {
              document.querySelector('.normal-view').style.visibility = 'visible';
              document.querySelector('.changeing').style.animationPlayState = 'running';
              document.querySelector('.changeing').style.animationDirection = 'reverse';
              clearInterval(interval);
              interval = null;
            }
          }
        }, 500);
      }
    }

    topValue = event.srcElement.scrollTop;
    // 滚动的高度
    const scrollTop = event.srcElement.scrollTop;
    if (scrollTop === 0) {
      if (document.querySelector('.normal-view')) {
        document.querySelector('.normal-view').style.visibility = 'hidden';
      }
    }
    // console.log('scrollTop',scrollTop);
    // 判断用户当前是否进行了横向滚动，如果用户发生了横向滚动，则设置元素为static
    // const scrollLeft =
    //   (event.srcElement
    //     ? event.srcElement.documentElement.scrollLeft
    //     : false) ||
    //   window.pageXOffset ||
    //   (event.srcElement ? event.srcElement.body.scrollLeft : 0);
    if (scrollTop > 50 && !this.state.show) {
      this.setState({ show: true });
      window.removeEventListener('scroll', this.bindHandleScroll);
    }
  };

  //在componentWillUnmount，进行scroll事件的注销
  componentWillUnmount() {
    window.removeEventListener('scroll', this.bindHandleScroll);
  }

  scrollToAnchor = (anchorName) => {
    if (anchorName) {
      // 找到锚点
      let anchorElement = document.getElementById(anchorName);
      // 如果对应id的锚点存在，就跳转到锚点
      if (anchorElement) {
        if (!this.props.scrollInRefeshView) {
          anchorElement.scrollIntoView({ block: 'start', behavior: 'smooth' });
        } else {
          anchorElement.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }
      } else {
        console.log('找不到顶部描点');
      }
    }
  };

  renderNormal = () => {
    return (
      <div className={'item'}>
        <CommonBtn
          className="button"
          title="返回顶部"
          onClick={() => {
            this.scrollToAnchor(this.props.anchorName);
            this.props.onClick && this.props.onClick();
          }}
        />
      </div>
    );
  };

  renderSpecial = () => {
    return (
      <div
        className="circle"
        onClick={() => {
          this.scrollToAnchor(this.props.anchorName);
          this.props.onClick && this.props.onClick();
        }}>
        <img
          src={`${CDN_BASE}/assets/imgs/common/goto.png`}
          style={{ width: '180px', height: '180px' }}
        />
      </div>
    );
  };

  render() {
    const { special } = this.props;
    return (
      <div className={cx(!special ? 'scroll-top-view' : 'normal-view')} alignContent="center">
        {this.state.show && (special ? this.renderSpecial() : this.renderNormal())}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pubBiz/ScrollTop/index.js